import { render } from "./IndexErrorNotFound.vue?vue&type=template&id=6eccca80"
import script from "./IndexErrorNotFound.vue?vue&type=script&lang=js"
export * from "./IndexErrorNotFound.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__